import { PlatformRole } from '../../models/platform-access.models';

export interface AppNavigationItem {
  label: string;
  route: string;
  icon: string;
  exact?: boolean;
  aliases?: string[];
  requiredRoles?: PlatformRole[];
  children?: AppNavigationItem[];
}

export const APP_NAVIGATION_ITEMS: AppNavigationItem[] = [
  {
    label: 'Dashboard',
    route: '/',
    icon: 'home-outline',
    exact: true
  },
  {
    label: 'Websites',
    route: '/websites',
    icon: 'globe-outline',
    children: [
      {
        label: 'All websites',
        route: '/websites',
        icon: 'globe-outline',
        exact: false,
        aliases: ['/website-builder', '/website-templates']
      },
      {
        label: 'Translations',
        route: '/website-translations',
        icon: 'language-outline'
      }
    ]
  },
  {
    label: 'Components',
    route: '/components',
    icon: 'cube-outline',
    children: [
      {
        label: 'Component library',
        route: '/component-library',
        icon: 'library-outline',
        exact: true,
        aliases: ['/component-builder', '/component-templates']
      },
      {
        label: 'Component marketplace',
        route: '/component-marketplace',
        icon: 'storefront-outline'
      }
    ]
  },
  {
    label: 'AI',
    route: '/ai',
    icon: 'sparkles-outline',
    children: [
      { label: 'Chat', route: '/ai/chat', icon: 'chatbubble-ellipses-outline', exact: true },
      { label: 'Usage & credits', route: '/ai/usage', icon: 'stats-chart-outline', exact: true }
    ]
  },
  {
    label: 'Administration',
    route: '/admin',
    icon: 'shield-checkmark-outline',
    requiredRoles: ['owner'],
    children: [
      {
        label: 'Plans & billing config',
        route: '/admin/plans',
        icon: 'card-outline',
        exact: true,
        requiredRoles: ['owner']
      },
      {
        label: 'Users & access',
        route: '/admin/users',
        icon: 'people-outline',
        exact: true,
        requiredRoles: ['owner']
      },
      {
        label: 'Product analytics',
        route: '/admin/analytics',
        icon: 'pulse-outline',
        exact: true,
        requiredRoles: ['owner']
      }
    ]
  }
];
